import React from "react";

/** 派单下拉选项：本项目「主办 / 协办」置顶（projectStaff 来自 /engine · projectStaff），其余同事在后。 */
export const AssigneeOptions = ({ projectStaff = [], staff = [], zh = true, T = (x) => x }) => {
  const top = new Set(projectStaff.map((s) => s.username));
  const rest = staff.filter((s) => !top.has(s.username));
  return (
    <>
      {projectStaff.length > 0 && (
        <optgroup label={zh ? "本项目 · 主办 / 协办" : "This project · primary / co-assist"} data-testid="assignee-group-project">
          {projectStaff.map((s) => <option key={s.username} value={s.username} data-co={s.co ? "1" : "0"}>{T(s.name)} · {zh ? s.role : s.roleEn}</option>)}
        </optgroup>
      )}
      <optgroup label={projectStaff.length ? (zh ? "其他同事" : "Other staff") : (zh ? "同事" : "Staff")} data-testid="assignee-group-other">
        {rest.map((s) => <option key={s.username} value={s.username}>{T(s.name)}</option>)}
      </optgroup>
    </>
  );
};

/** 任务执行人旁的「协办」小标签 */
export const CoTag = ({ kind, zh = true }) => kind === "co"
  ? <span className="text-[8px] font-bold px-1 py-px rounded bg-violet-100 text-violet-700 align-middle" data-testid="assignee-co-tag">{zh ? "协办" : "co"}</span>
  : null;
